// Locale-aware, accent-sensitive, case-insensitive substring match
export const localeIncludes = (haystack: string, needle: string): boolean => {
  if (!needle) { return true; }
  const collator = new Intl.Collator(undefined, { sensitivity: 'accent', usage: 'search' });
  const n = needle.length;
  for (let i = 0; i <= haystack.length - n; i++) {
    if (collator.compare(haystack.substr(i, n), needle) === 0) {
      return true;
    }
  }
  return false;
};


